import React, { useContext } from 'react'
import { fareCabinLabelMap, FlightsClassTypes } from 'constants/flight'
import OfferFilterDropdownBox from '../OfferFilterDropdownBox'
import LineSeatIcon from 'LuxKit/Icons/line/LineSeatIcon'
import ModalContext from 'contexts/ModalContext'
import MaldivesCharterFlightFareClassModal from './MaldivesCharterFlightFareClassModal'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'

interface Props {
  fareClass: FlightsClassTypes
  className?: string
  checkInDate?: string
  checkOutDate?: string
  occupancies: Array<App.Occupants>
}

function CharterFlightFareClassSelect({ fareClass, className, checkInDate, checkOutDate, occupancies }: Props) {
  const openModal = useContext(ModalContext)
  const dispatch = useOfferPageDispatch()

  const openFareClassModal = async() => {
    const selectedClass = await openModal<FlightsClassTypes>(<MaldivesCharterFlightFareClassModal
      selectedClassId={fareClass}
      checkInDate={checkInDate}
      checkOutDate={checkOutDate}
      occupancies={occupancies}
    />)
    if (selectedClass) {
      dispatch({ type: OfferPageActions.setFareClass, fareClass: selectedClass })
    }
  }

  return (
    <OfferFilterDropdownBox
      className={className}
      data-testid="fare-class-select"
      onClick={openFareClassModal}
      icon={<LineSeatIcon />}
      label="Class"
      value={fareCabinLabelMap[fareClass]}
      placeholder="Select fare class"
    />
  )
}

type MappedProps = Pick<Props, 'fareClass' | 'checkInDate' | 'checkOutDate' | 'occupancies'>

export default withOfferPageState((state): MappedProps => ({
  fareClass: state.fareClass,
  checkInDate: state.checkInDate,
  checkOutDate: state.checkOutDate,
  occupancies: state.rooms,
}), CharterFlightFareClassSelect)
